<template>
    <div class="out-container">
        <div class="left-nav">
            <dl>
                <dt>主体信息</dt>
                <dd>
                    <ul>
                        <li v-for="(item,index) in commonList" :key="index"
                            :class="commonListActive == index ? 'active' : null"
                            @click="tabToggle(index)">
                            <i class="left-nav-icon"></i>
                            {{item.name}}
                            <i class="right-nav-icon"></i>
                        </li>
                    </ul>
                </dd>
            </dl>
        </div>
        <div class="right-content">
            <mainBasicInfoView v-if="commonListActive == 0" />
            <mainQualifications v-if="commonListActive == 1" />
            <mainMembers v-if="commonListActive == 2" />
            <mainAchievement v-if="commonListActive == 3" />
            <mainRewards v-if="commonListActive == 4" />
        </div>
    </div>
</template>

<script>
    import mainBasicInfoView from './mainDealManagementDetail/main-basicInfo-view';
    import mainQualifications from './mainDealManagementDetail/main-qualifications-form';
    import mainMembers from './mainDealManagementDetail/main-members-form';
    import mainAchievement from './mainDealManagementDetail/main-achievement-form';
    import mainRewards from './mainDealManagementDetail/main-rewards-form';

    export default {
        data() {
            return {
                commonListActive: 0,
                commonList: [
                    {
                        name:'主体基本信息',
                    },{
                        name:'主体证书信息',
                    },{
                        name:'主体人员信息',
                    },{
                        name:'主体业绩信息',
                    }, {
                        name:'主体奖惩信息',
                    }
                ]
            }
        },
        mounted() {

        },
        components: {
            mainBasicInfoView,
            mainQualifications,
            mainMembers,
            mainAchievement,
            mainRewards,
        },
        methods: {
            tabToggle (index) {
                this.commonListActive = index;
            },
        },
        filters: {
            dateFilter: function (value) {
                if (value) {
                    return value.split(' ')[0]
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .out-container{
        display: flex;
        .left-nav{
            width: 265px;
            border: 1px #CCCCCC solid;
            border-bottom: 0;
            min-height: 650px;
            background: #fff;
            position: relative;
            dl{
                dt{
                    width: 100%;
                    height: 120px;
                    line-height: 120px;
                    text-align: center;
                    font-size: 30px;
                    position: relative;
                    font-weight: 400;
                    color: #fff;
                    background: url(../../../assets/img/left_nav_dt.png) no-repeat;
                    background-size: 100% 100%;
                }
                dd{
                    ul{
                        li{
                            width: 100%;
                            font-size: 16px;
                            line-height: 50px;
                            text-indent: 30px;
                            border-top: 1px #DEDEDE dotted;
                            position: relative;
                            cursor: pointer;
                            i{
                                display: block;
                                position: absolute;
                                width: 20px;
                                height: 20px;
                                margin-top: 10px;
                            }
                            .left-nav-icon{
                                top: 10px;
                                left: 10px;
                                background: url(../../../assets/img/no_check_left.png) 0 0 no-repeat;
                            }
                            .right-nav-icon{
                                top: 10px;
                                right: 30px;
                                background: url(../../../assets/img/no_check_right.png) 0 0 no-repeat;
                            }
                        }
                        li:nth-last-child(1){
                            border-bottom: 1px #DEDEDE dotted;
                        }
                        li.active{
                            color: #0061DC;
                            .left-nav-icon{
                                top: 10px;
                                left: 10px;
                                background: url(../../../assets/img/check_left_cur.png) 0 0 no-repeat;
                            }
                            .right-nav-icon{
                                top: 10px;
                                right: 30px;
                                background: url(../../../assets/img/check_right_cur.png) 0 0 no-repeat;
                            }
                        }
                    }
                }
            }
        }
        .right-content{
            width: 1155px;
            min-height: 650px;
            background: #fff;
        }
    }
    @media screen and (max-width: 1200px){
        .out-container{
            .left-nav{
                width: 285px;
            }
            .right-content{
                width: 915px;
            }
        }
    }
    @media screen and (max-width: 967px){
        .out-container{
            .left-nav{
                width: 200px;
            }
            .right-content{
                width: 767px;
            }
        }
    }
</style>